import type { OutboxStatus } from "@/lib/outbox";

// Redacción del veredicto del servidor sobre una mutación encolada sin red. Vive en `lib/` —y no
// en `features/sync/`, de donde bajó con #306— porque la necesitan DOS features: el centro de
// sincronización, que lista cada mutación no resuelta con su motivo, y la ficha del LOTO, que
// cierra con un aviso la ficha temporal de un alta rechazada. `features/*` usa `lib/*`, nunca
// entre features, así que este es su sitio; y una sola redacción por `error_code` es justo lo que
// impide que dos pantallas cuenten el mismo rechazo de dos maneras distintas.
//
// El servidor es la única autoridad: aquí solo se DESCRIBE su veredicto, nunca se auto-resuelve.

/**
 * traducirEstadoServidor traduce el `error_code` del veredicto (o el marcador local DEP_NO_RESUELTA
 * de una dependencia bloqueada) a una frase que describe el ESTADO DEL SERVIDOR frente a la
 * intención del técnico. Sin código específico, describe por estado.
 */
export function traducirEstadoServidor(status: OutboxStatus, errorCode?: string): string {
  switch (errorCode) {
    case "CANDADO_YA_ACTIVO":
      return "El candado ya estaba colocado en otro bloqueo activo del servidor.";
    case "LOTO_CERRADO":
      return "El LOTO se cerró en el servidor: ya no admite nuevos candados.";
    case "SYNC_CONFLICT":
      return "Otro técnico ya había retirado este candado.";
    case "RETIRO_NO_PERMITIDO":
      return "No tienes permiso para retirar este candado (ni lo colocaste ni eres supervisor).";
    case "LOTO_NO_ENCONTRADO":
      return "El LOTO al que pertenece ya no existe en el servidor.";
    case "BLOQUEO_NO_ENCONTRADO":
      return "El candado que se intentaba retirar ya no existe en el servidor.";
    case "BLOQUEO_TIENE_PUNTOS_ACTIVOS":
      return "El candado aún tiene puntos sin retirar; retíralos uno a uno.";
    case "PUNTO_NO_ENCONTRADO":
      return "El punto que se intentaba retirar ya no lo cubre ese candado en el servidor.";
    case "NUMERO_DUPLICADO":
      return "Ya existe un LOTO con ese número en el servidor.";
    case "EQUIPO_NO_LOTEABLE":
      return "El equipo no admite bloqueo LOTO.";
    case "EQUIPO_INACTIVO":
      return "El equipo está inactivo.";
    case "VALIDACION":
    case "PAYLOAD_INVALIDO":
      return "Los datos de la operación no son válidos.";
    case "OP_NO_SOPORTADA":
      return "El servidor no admite esta operación.";
    case "DEP_NO_RESUELTA":
      return "Depende de otra operación que aún no se pudo aplicar.";
    case "CLIENT_MUTATION_ID_INVALIDO":
    case "CLIENT_UUID_INVALIDO":
      return "La operación llevaba un identificador inválido.";
    default:
      break;
  }
  switch (status) {
    case "conflict":
      return "Chocó con el estado actual del servidor.";
    case "rejected":
      return "El servidor rechazó la operación.";
    case "blocked":
      return "Bloqueada a la espera de otra operación.";
    default:
      return "Pendiente de enviar al servidor.";
  }
}
